import axios from 'axios';
import useAuthStore from '../../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const getCategories = async (type, language) => {
  const url = `/categories/${type}${language ? `?language=${language}` : ''}`;
  const response = await api.get(url);
  return response.data;
};

export const getCategoriesByLanguage = async (type, language) => {
  const response = await api.get(`/categories/${type}/language/${language}`);
  return response.data;
};

export const getCategoryByName = async ({ type, name, language }) => {
  const url = `/categories/${type}/name/${name}${language ? `?language=${language}` : ''}`;
  const response = await api.get(url);
  return response.data;
};

export const createCategory = async ({ type, name, language = 'english' }) => {
  const response = await api.post(`/categories/${type}`, { name, language });
  return response.data;
};

export const updateCategory = async ({ type, categoryId, name, language }) => {
  const response = await api.put(`/categories/${type}/${categoryId}`, { name, language });
  return response.data;
};

export const deleteCategory = async ({ type, categoryId }) => {
  const response = await api.delete(`/categories/${type}/${categoryId}`);
  return response.data;
};